import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
interface KeyTakeawaysProps {
  points: string[];
}
export function KeyTakeaways({
  points
}: KeyTakeawaysProps) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-1 shadow-2xl my-12 relative overflow-hidden" data-id="element-168">
      {/* Gold Border Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-yellow-400 via-yellow-200 to-yellow-500 opacity-20 animate-pulse" data-id="element-169"></div>

      <div className="bg-slate-900 rounded-xl p-8 relative z-10 border border-yellow-500/30" data-id="element-170">
        <div className="flex items-center gap-3 mb-6" data-id="element-171">
          <div className="p-2 bg-yellow-500/20 rounded-full" data-id="element-172">
            <Star className="w-6 h-6 text-yellow-400 fill-yellow-400" data-id="element-173" />
          </div>
          <h3 className="text-2xl font-bold text-white" data-id="element-174">Key Takeaways</h3>
        </div>

        <div className="grid md:grid-cols-2 gap-4" data-id="element-175">
          {points.map((point, index) => <div key={index} className="flex items-start gap-3 p-3 rounded-lg bg-slate-800/50 border border-slate-700" data-id="element-176">
              <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" data-id="element-177" />
              <span className="text-slate-200 font-medium" data-id="element-178">{point}</span>
            </div>)}
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-yellow-500/10 rounded-full blur-2xl" data-id="element-179"></div>
      <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-purple-500/10 rounded-full blur-2xl" data-id="element-180"></div>
    </motion.div>;
}